import { Label } from 'components/atoms';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { PiCheck, PiQuestion, PiWarningCircle } from 'react-icons/pi';
import { STATEMENT_CONSISTANCY } from 'services/statements/types';
import { IColorProp } from 'types/components/components.interface';

export interface ILabeledStatementConsistancyProps {
  status: STATEMENT_CONSISTANCY;
}

interface ILabeledStatementConsistancyParams extends IColorProp {
  status: STATEMENT_CONSISTANCY;
  icon: ReactNode;
}

const labeledStatusParams: ILabeledStatementConsistancyParams[] = [
  {
    status: STATEMENT_CONSISTANCY.consistent,
    color: 'blue',
    icon: <PiCheck />,
  },
  {
    status: STATEMENT_CONSISTANCY.partiallyConsistent,
    color: 'orange',
    icon: <PiQuestion />,
  },
  {
    status: STATEMENT_CONSISTANCY.inconsistent,
    color: 'red',
    icon: <PiWarningCircle />,
  },
];

const LabeledStatementConsistancy = ({
  status,
}: ILabeledStatementConsistancyProps) => {
  const { t } = useTranslation();
  const labeledParams =
    labeledStatusParams.find(params => params.status === status) ??
    labeledStatusParams[0];
  return (
    <Label
      size='compact'
      color={labeledParams.color}
      title={t(
        `enum.STATEMENT_CONSISTANCY.${
          STATEMENT_CONSISTANCY[labeledParams.status]
        }`
      )}>
      {labeledParams.icon}{' '}
      {t(
        `enum.STATEMENT_CONSISTANCY.${
          STATEMENT_CONSISTANCY[labeledParams.status]
        }`
      )}
    </Label>
  );
};

export default LabeledStatementConsistancy;
